module.exports = __webpack_public_path__ + "img/世航业绩选中.5cf9ab8f.png";